import { rgba } from 'polished'
import blue from '@mui/material/colors/blue'

import { padding } from 'common.styles'

export const globalStyle = theme => ({
  html: {
    WebkitFontSmoothing: 'auto'
  },
  'a:not([role="button"])': {
    color: 'inherit',
    textDecoration: 'none',
    transition: 'ease-out 0.2s',
    transitionProperty: 'color',
    '&:hover': {
      color: blue[700]
    }
  },
  '.notfound': {
    height: theme.sizing.mdGridSize * 24,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    '& a': {
      marginTop: theme.sizing.mdGridSize * 2
    }
  },
  '.CookieConsent': {
    background: `${rgba(theme.palette.background.paper, 0.8)} !important`,
    backdropFilter: 'saturate(180%) blur(20px)',
    color: `${theme.palette.text.primary} !important`,
    fontSize: theme.typography.overline.fontSize,
    paddingBlock: theme.spacing(2),
    paddingInline: theme.spacing(2.5),
    flexWrap: 'nowrap !important',
    alignItems: 'center !important',
    gap: theme.spacing(0.5),
    '& .cookie-consent-content': {
      margin: '0 !important',
      flex: '1 0 0 !important'
    },
    '& .accept-cookie-btn': {
      fontFamily: theme.typography.fontFamily,
      fontSize: 'inherit',
      padding: `${theme.spacing(0.5)} !important`,
      background: `${theme.palette.warning.light} !important`,
      color: `${theme.palette.warning.contrastText} !important`,
      margin: '0 !important',
      borderRadius: `${theme.shape.borderRadius}px !important`,
      whiteSpace: 'nowrap'
    }
  },
  '.modal': {
    background: `${rgba(theme.palette.background.paper, 0.7)} !important`,
    backdropFilter: 'saturate(180%) blur(40px)',
    '& .close': {
      color: theme.palette.text.primary
    }
  }
})

export const rootStyle = () => ({
  position: 'relative',
  zIndex: 0,
  backgroundColor: 'background.default',
  color: 'text.primary'
})

export const navStyle = (theme) => {
  const { paper } = theme.palette.background
  const { black } = theme.palette.common
  const { borderRadius } = theme.shape

  return {
    position: 'sticky',
    top: 0,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    ...padding(),
    background: rgba(paper, 0.8),
    backdropFilter: 'saturate(180%) blur(20px)',
    boxShadow: `0 16px 32px ${rgba(black, 0.025)}`,
    transition: 'ease-out 0.2s',
    transitionProperty: 'transform, opacity',
    zIndex: 100,
    height: {
      xs: 2.5 * theme.sizing.mdGridSize,
      md: 3 * theme.sizing.mdGridSize,
    },
    borderRadius: {
      xs: `0 0 ${3 * borderRadius}px ${3 * borderRadius}px`,
      md: `0 0 ${4 * borderRadius}px ${4 * borderRadius}px`,
    },
  }
}

export const navEndStyle = () => ({
  display: 'flex',
  alignItems: 'center',
  gap: {
    xs: 1,
    sm: 1.5,
    md: 2
  }
})

export const logoStyle = () => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 1.5
})

export const logoIconStyle = theme => ({
  width: theme.sizing.mdGridSize,
  height: (theme.sizing.mdGridSize * 3) / 4,
})

export const logoTypeStyle = () => ({
  fontWeight: 'fontWeightBold',
  fontSize: 10,
  textTransform: 'uppercase',
  letterSpacing: 1.5,
})
